import AuthenticationSlicer from "./slices/AuthenticationSlicer";
import PersonalInformationSlicer from "./slices/personalInformationSlicer";

function Store({ children }) {
    return (
        <AuthenticationSlicer>
            <PersonalInformationSlicer>
                {children}
            </PersonalInformationSlicer>
        </AuthenticationSlicer>
    );
}

export default Store;
